
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { API } from '../utils/api';

export function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      if (!email) {
        toast.error('Please enter your email');
        return;
      }
      const emailOk = /.+@.+\..+/.test(email);
      if (!emailOk) {
        toast.error('Please enter a valid email');
        return;
      }
      setLoading(true);
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Reset link sent');
    } catch (e) {
      const detail = e.response?.data?.detail;
      const msg = Array.isArray(detail)
        ? detail.map((d) => d.msg).join(', ')
        : detail;
      toast.error(msg || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Forgot Password</CardTitle>
          <CardDescription>Enter your email to receive a reset link</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {!sent ? (
            <>
              <div>
                <Label>Email</Label>
                <Input value={email} onChange={e => setEmail(e.target.value)} type="email" data-testid="forgot-email-input" />
              </div>
              <Button
                className="w-full"
                onClick={handleSubmit}
                data-testid="forgot-submit-button"
                disabled={loading}
                type="button"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
              <Button
                className="w-full"
                variant="outline"
                onClick={() => navigate('/')}
                data-testid="forgot-back-home"
              >
                Back to Home
              </Button>
            </>
          ) : (
            <div className="text-center space-y-4">
              <div className="text-green-600 font-medium">Link sent! Check your email.</div>
              <Button variant="outline" onClick={() => navigate('/')} data-testid="forgot-back-login">Back to Login</Button>
            </div>
          )}
        </CardContent>
      </Card>
      <Toaster richColors />
    </div>
  );
}
